import { Search } from 'lucide-react';

import { Input } from '@/components/ui/input';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

import { ALLOWED_FILE_TYPES } from '@/constants';

import { useDocumentsTableStore } from '@/store/documents-table.store';

export function DocumentSearchFilter() {
  const query = useDocumentsTableStore(state => state.query);
  const typeFilter = useDocumentsTableStore(state => state.filters.type);
  const setQuery = useDocumentsTableStore(state => state.setQuery);
  const setFilter = useDocumentsTableStore(state => state.setFilter);

  return (
    <div className="flex items-center gap-4">
      <div className="flex-1 max-w-md">
        <div className="relative">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
          <Input
            placeholder="Search documents..."
            value={query}
            onChange={e => setQuery(e.target.value)}
            className="pl-10"
          />
        </div>
      </div>
      <Select value={typeFilter} onValueChange={value => setFilter('type', value)}>
        <SelectTrigger className="w-[135px]">
          <SelectValue placeholder="All types" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All types</SelectItem>
          {ALLOWED_FILE_TYPES.map(type => (
            <SelectItem key={type} value={type}>
              {type.toUpperCase()}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
